import { ElementResultInfo } from "projects/phdsoft/common/src/lib/models/element-result-info.model";
import { ChecklistItem } from "src/app/collections/collection-inspection/_models/checklist.model";
import { StructuralElement } from "../StructureElements/StructuralElement";
import { WorkableElement } from "../WorkableElement";
import { GaugingPoint } from "./gaugingPoint";
import * as THREE from '@phdsoft/three';
import { GraphicsMaterials } from "src/app/digital-twin/graphics/graphics-materials";


export class SteelThicknessGaugingPoint extends GaugingPoint {

    private static _excessiveCorrosionMaterial: THREE.Material;
    public static get excessiveCorrosionMaterial(): THREE.Material {
        return this._excessiveCorrosionMaterial;
    }
    public static set excessiveCorrosionMaterial(v: THREE.Material) {
        this._excessiveCorrosionMaterial = v;
    }
 
    private static _substantialCorrosionMaterial: THREE.Material;
    public static get substantialCorrosionMaterial(): THREE.Material {
        return this._substantialCorrosionMaterial;
    }
    public static set substantialCorrosionMaterial(v: THREE.Material) {
        this._substantialCorrosionMaterial = v;
    }
 
    private static _acceptableCorrosionMaterial: THREE.Material;
    public static get acceptableCorrosionMaterial(): THREE.Material {
        return this._acceptableCorrosionMaterial;
    }
    public static set acceptableCorrosionMaterial(v: THREE.Material) {
        this._acceptableCorrosionMaterial = v;
    }
 
    private static _overThicknessMaterial: THREE.Material;
    public static get overThicknessMaterial(): THREE.Material {
        return this._overThicknessMaterial;
    }
    public static set overThicknessMaterial(v: THREE.Material) {
        this._overThicknessMaterial = v;
    }

    private _currentThickness: any;
    public get currentThickness(): any {
        return this._currentThickness;
    }
    public set currentThickness(v: any) {
        this._currentThickness = v;
    }



    // curveType?: string; // curveType may be Linear or Exponential
    // curveParameters?: [number, number];

    // ReadingQuality?: any;
    // ExposureTime?: any;
    // EstimatedLostThickness?: any;
    EstimatedThickness?: any;
    // AbsoluteDegradation?: any;
    // CorrosionRiskIndex?: any;
    // RelativeDegradation?: any;
    // CorrosionRate?: any;
    // RemainingLife?: any;



    private _degradationRate: number;
    public get degradationRate(): number {
        return this._degradationRate;
    }
    public set degradationRate(v: number) {
        this._degradationRate = v;
    }

    public get elementRuleThickness(): number {
        if (this.targetElement instanceof StructuralElement) {
            return (this.targetElement as StructuralElement).ruleThickness;
        }
        return null;
    }

    public get elementOriginalThickness(): number {
        if (this.targetElement instanceof StructuralElement) {
            return (this.targetElement as StructuralElement).thickness;
        }
        return null;
    }

    public get elementOriginalBuildingDate(): number {
        if (this.targetElement instanceof StructuralElement) {
            return (this.targetElement as StructuralElement).properties?.General?.Collection?.Date;
        }
        return null;
    }

    public get elementAdmissibleCorrosion(): number {
        if (this.targetElement instanceof StructuralElement) {
            return (this.targetElement as StructuralElement).admissibleCorrosion;
        }
        return null;
    }

    // private _absoluteDegradation: number = 0
    // public get absoluteDegradation(): number {
    //     this._absoluteDegradation = 100.0 * (this.elementRuleThickness - this.EstimatedThickness
    //       ) / this.elementRuleThickness;

    //     //if (absoluteDegradation < 0 && this._currentThickness <= this.elementOriginalThickness)
    //     //    absoluteDegradation = 0.0;

    //     //if (absoluteDegradation < 0 && Math.abs(absoluteDegradation) < 1)
    //     //    absoluteDegradation = -1.0;

    //     if (this._absoluteDegradation >= Number.MAX_SAFE_INTEGER)
    //         return Number.MAX_SAFE_INTEGER;
    //     if (this._absoluteDegradation <= Number.MIN_SAFE_INTEGER)
    //         return Number.MIN_SAFE_INTEGER;

    //     // if(absoluteDegradation < 0) return 0
    //     return this._absoluteDegradation;
    // }

    // private _relativeDegradation: number = 0
    // public get relativeDegradation(): number {
    //     let absoluteDegradation = this.absoluteDegradation;
    //     if (absoluteDegradation == 0 || (this.targetElement as StructuralElement).admissibleCorrosion == 0)
    //         return 0;

    //     this._relativeDegradation = 100.0 * absoluteDegradation / (this.targetElement as StructuralElement).admissibleCorrosion;

    //     if (this._relativeDegradation >= Number.MAX_SAFE_INTEGER)
    //         return Number.MAX_SAFE_INTEGER;
    //     if (this._relativeDegradation <= Number.MIN_SAFE_INTEGER)
    //         return Number.MIN_SAFE_INTEGER;

    //     return this._relativeDegradation;
    // }

    // public get remainingThicknessLife(): number {
    //     let remainedLife = 0;
    //     if (this.degradationRate < 0) {
    //         return Number.NEGATIVE_INFINITY;
    //     }

    //     if (this.degradationRate <= 0.0001) {
    //         remainedLife = 50.0;
    //     }
    //     else {
    //         let remainedThickness = this._currentThickness - (1 - this.elementAdmissibleCorrosion) * this.elementRuleThickness;
    //         if (remainedThickness > 0)
    //             remainedLife = remainedThickness / this.degradationRate;
    //     }

    //     return remainedLife;
    // }

    public static get emptyValueMaterial() {
        return GraphicsMaterials.pointMaterial;
    }
    public static set emptyValueMaterial(value) {
        GraphicsMaterials.pointMaterial = value;
    }

    // private override _gaugingValue;
    public set gaugingValue(v: number) {
        this._gaugingValue = v;
        // if (this.targetElement instanceof StructuralElement) {
        //     const hasValue = this.checkList.some(c => c.Value != "" && c.Value != "0" && c.Value != null)
        //     const structure = this.targetElement as StructuralElement;
        //     if (v === 0 && !hasValue) this.defaultMaterial = SteelThicknessGaugingPoint.emptyValueMaterial;
        //     else if (structure.ruleThickness == 0 || structure.ruleThickness == null) this.defaultMaterial = SteelThicknessGaugingPoint.overThicknessMaterial;
        //     else if (v <= +(structure.excessiveCorrosionThickness.toFixed(2))) this.defaultMaterial = SteelThicknessGaugingPoint.excessiveCorrosionMaterial;
        //     else if (v <= +(structure.substantialCorrosionThickness.toFixed(2))) this.defaultMaterial = SteelThicknessGaugingPoint.substantialCorrosionMaterial;
        //     // else if (v >= +((structure.ruleThickness * 1.1).toFixed(2))) this.defaultMaterial = SteelThicknessGaugingPoint.overThicknessMaterial;
        //     else if (v >= +((structure.thickness * 1.1).toFixed(2))) this.defaultMaterial = SteelThicknessGaugingPoint.overThicknessMaterial;
        //     else this.defaultMaterial = SteelThicknessGaugingPoint.acceptableCorrosionMaterial;
        // }
    }

    public get gaugingValue(): number {
        return this._gaugingValue;
    }

    constructor(mesh: THREE.Mesh, material: THREE.Material, targetElement: WorkableElement, checkList: Array<ChecklistItem>, _elementResult: ElementResultInfo) {
        super(mesh, material, targetElement, checkList, _elementResult);
        this.elementTypeName = 'SteelThicknessGaugingPoint';
        if (_elementResult && _elementResult.CheckList && _elementResult.CheckList.length > 0)
            this.gaugingValue = Number(_elementResult.CheckList[_elementResult.CheckList.length - 1]?.Value) ?? 0;
    }

    // TODO: this has absolutely nothing to do with material.....
    public updateMaterial(data: Date): void {
        let index = 0;
        if (this.checkList && this.checkList && this.checkList.length > 0)
            this.checkList = this.checkList.sort((a, b) => new Date(a.Date).getTime() - new Date(b.Date).getTime())
            this.checkList.forEach((checkList) => {
                let formattedDate = new Date(new Date(checkList.Date).toDateString())
                if (data >= formattedDate) {
                    this.gaugingValue = Number(this.checkList[index]?.Value) ?? 0;
                }
                index++;
            })

    }

    // public setDegradationCurveParameters(parameters: DegradationCurveParameters, date?: Date){
    //   this.curveType = parameters.CurveType;
    //   this.curveParameters = [parameters.CurveParameters[0], parameters.CurveParameters[1]];

    //   if(date) this.setDegradationProperties(date)
    // }

//     public setDegradationProperties(date: Date): void{
//       const structure = this.targetElement as StructuralElement;
//       const wastageAllowance: number = (structure.properties.Geometry?.WastageAllowance ?? 20)?.toFixed(2);
//       const excessiveCorrosionThickness = this.elementRuleThickness * ( 1 - ( wastageAllowance / 100 ))
//       if(this.curveType && this.curveParameters){
//         this.RemainingLife = 0
//         if(this.curveType == "Linear"){

//           if(this.checkList.some(ck => Number(ck.Value) < this.elementOriginalThickness )){
//               if(this.curveParameters[0] != 0 || this.curveParameters[1] != 0){
//                 const intercept = this.curveParameters[0]
//                 const slope = this.curveParameters[1]
//                 const time = ( new Date(date).getTime() - new Date(this.elementOriginalBuildingDate).getTime() ) / (1000*60*60*24)
//                 const riskIndex = 1
//                 const structure = this.targetElement as StructuralElement;

//                 this.ExposureTime = time/365
//                 this.EstimatedLostThickness = intercept + ( time * slope )

//                 this.EstimatedThickness = this.elementOriginalThickness - this.EstimatedLostThickness
//                 this.gaugingValue = this.EstimatedThickness
//                 this.currentThickness = this.EstimatedThickness

//                 this.CorrosionRate = slope * 365
//                 this.CorrosionRiskIndex = this.absoluteDegradation * riskIndex
//                 if(this.EstimatedThickness > excessiveCorrosionThickness){
//                   const lostThicknessLimit = this.elementOriginalThickness - excessiveCorrosionThickness
//                   const lifeTime = ( lostThicknessLimit - intercept ) / slope
//                   this.RemainingLife = (lifeTime - time ) / 365
//                 }
//               }
//           }else{
//             this.ExposureTime = ''
//             this.EstimatedLostThickness = ''
//             this.EstimatedThickness = ''
//             this.currentThickness = ''
//             this.RemainingLife = Infinity
//             this.CorrosionRate = ''
//             this.CorrosionRiskIndex = ''
//           }
//         }
//         else if (this.curveType == "Exponential"){
//           const a = this.curveParameters[0]
//           const b = this.curveParameters[1]
//           const time = ( new Date(date).getTime() - new Date(this.elementOriginalBuildingDate).getTime() ) / (1000*60*60*24)
//           const riskIndex = 1
//           const structure = this.targetElement as StructuralElement;

//           this.ExposureTime = time/365
//           this.EstimatedLostThickness = a * Math.pow(time, b )

//           this.EstimatedThickness = this.elementOriginalThickness - this.EstimatedLostThickness
//           this.gaugingValue = this.EstimatedThickness
//           this.currentThickness = this.EstimatedThickness

//           this.CorrosionRate = 365 * a * b * Math.pow(time, b - 1)
//           this.CorrosionRiskIndex = this.absoluteDegradation * riskIndex

//           if(this.EstimatedThickness > excessiveCorrosionThickness){
//             const lostThicknessLimit = this.elementOriginalThickness - excessiveCorrosionThickness
//             const lifeTime = Math.pow(( lostThicknessLimit / a ), 1 / b )
//             this.RemainingLife = ( lifeTime - time ) / 365
//           }
//         }
//       }
//     }
}
